import { useEffect, useRef, useState } from "react";
import { Columns, LockSimple, ArrowCounterClockwise } from "@phosphor-icons/react";

// Checkbox dropdown to show/hide table columns. Pair with `useColumnPrefs`.
export function ColumnChooser({ columns, hiddenSet, onToggle, onReset }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, [open]);

  const hiddenCount = hiddenSet.size;
  return (
    <div className="relative" ref={ref}>
      <button type="button" data-testid="column-chooser-btn" onClick={() => setOpen((o) => !o)}
        title="Choose which columns are shown on this table"
        className={`h-10 px-3 border rounded-md text-sm font-semibold inline-flex items-center gap-1.5 bg-white transition-colors ${hiddenCount ? "border-green-400 text-green-700 hover:bg-green-50" : "border-slate-300 text-slate-600 hover:bg-slate-50"}`}>
        <Columns size={16} weight="bold" />
        Columns{hiddenCount ? <span className="text-xs font-bold">({hiddenCount} hidden)</span> : null}
      </button>
      {open && (
        <div data-testid="column-chooser-panel"
          className="absolute right-0 top-11 z-40 w-64 bg-white border border-slate-200 rounded-md shadow-lg p-2">
          <div className="px-2 py-1 text-[10px] font-bold uppercase tracking-widest text-slate-400">Show columns</div>
          <div className="max-h-72 overflow-y-auto">
            {columns.map((c) => (
              <label key={c.key}
                className={`flex items-center gap-2 px-2 py-1.5 rounded text-sm ${c.locked ? "text-slate-400" : "cursor-pointer hover:bg-slate-50 text-slate-700"}`}>
                <input type="checkbox" checked={!hiddenSet.has(c.key)} disabled={!!c.locked}
                  onChange={() => onToggle(c.key)} data-testid={`column-toggle-${c.key}`}
                  className="h-4 w-4 accent-green-600" />
                <span className="flex-1">{c.label}</span>
                {c.locked && <LockSimple size={12} weight="bold" title="Always shown" />}
              </label>
            ))}
          </div>
          <button type="button" data-testid="column-reset-btn" onClick={onReset}
            className="mt-1 w-full h-8 border-t border-slate-100 text-xs font-semibold text-slate-500 hover:text-slate-800 inline-flex items-center justify-center gap-1">
            <ArrowCounterClockwise size={12} weight="bold" /> Reset to default
          </button>
        </div>
      )}
    </div>
  );
}
